var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.61678 8.72101C-0.894266 6.77585 0.543293 4 3.0617 4H16.9383C19.4567 4 20.8943 6.77585 19.3832 8.72101C18.7383 9.55122 18.3897 10.561 18.3897 11.5987V19.3C18.3897 22.448 15.7464 25 12.4858 25H7.51417C4.25357 25 1.61032 22.448 1.61032 19.3V11.5987C1.61032 10.561 1.2617 9.55122 0.61678 8.72101ZM3.0617 5.8C2.07962 5.8 1.51903 6.88247 2.10828 7.64101C2.99523 8.78279 3.4747 10.1715 3.4747 11.5987V19.3C3.4747 21.4539 5.28323 23.2 7.51417 23.2H12.4858C14.7168 23.2 16.5253 21.4539 16.5253 19.3V11.5987C16.5253 10.1715 17.0048 8.78279 17.8917 7.64101C18.481 6.88247 17.9204 5.8 16.9383 5.8H3.0617Z",
    fill: "#EA1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10C12.7761 10 13 10.4029 13 10.9L13 18.1C13 18.5971 12.7761 19 12.5 19C12.2239 19 12 18.5971 12 18.1L12 10.9C12 10.4029 12.2239 10 12.5 10Z",
    fill: "#EA1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10C7.77614 10 8 10.4029 8 10.9L8 18.1C8 18.5971 7.77614 19 7.5 19C7.22386 19 7 18.5971 7 18.1L7 10.9C7 10.4029 7.22386 10 7.5 10Z",
    fill: "#EA1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73619 2.08921C5.20899 0.841554 6.53636 0 8.03148 0H11.9685C13.4636 0 14.791 0.841554 15.2638 2.08921L15.9511 3.90297C16.1166 4.33957 15.8483 4.81148 15.352 4.95701C14.8556 5.10255 14.3191 4.86659 14.1537 4.42999L13.4664 2.61623C13.2515 2.04912 12.6481 1.66659 11.9685 1.66659H8.03148C7.35188 1.66659 6.74853 2.04912 6.53362 2.61623L5.8463 4.42999C5.68085 4.86659 5.14436 5.10255 4.64801 4.95701C4.15167 4.81148 3.88342 4.33957 4.04887 3.90297L4.73619 2.08921Z",
    fill: "#EA1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b531f5e11db55d695c0601703d22e1f1.svg";
export { ForwardRef as ReactComponent };